export default {
  GETIPINFO_REQUEST: 'INTERNALS_GETIPINFO_REQUEST',
  GETIPINFO_SUCCESS: 'INTERNALS_GETIPINFO_SUCCESS',
  GETIPINFO_FAILURE: 'INTERNALS_GETIPINFO_FAILURE',

  IDENTITY_VERIFY_REQUEST: 'INTERNALS_IDENTITY_VERIFY_REQUEST',
  IDENTITY_VERIFY_SUCCESS: 'INTERNALS_IDENTITY_VERIFY_SUCCESS',
  IDENTITY_VERIFY_FAILURE: 'INTERNALS_IDENTITY_VERIFY_FAILURE',

  IDENTITY_QUESTIONS_REQUEST: 'INTERNALS_IDENTITY_QUESTIONS_REQUEST',
  IDENTITY_QUESTIONS_SUCCESS: 'INTERNALS_IDENTITY_QUESTIONS_SUCCESS',
  IDENTITY_QUESTIONS_FAILURE: 'INTERNALS_IDENTITY_QUESTIONS_FAILURE',

  ID_VERIFY_REQUEST: 'INTERNALS_ID_VERIFY_REQUEST',
  ID_VERIFY_SUCCESS: 'INTERNALS_ID_VERIFY_SUCCESS',
  ID_VERIFY_FAILURE: 'INTERNALS_ID_VERIFY_FAILURE',
};